<div class="card">
  <div class="card-header">
    PART SHIP ORDER
    <a *ngIf="enableEdit" (click)="editPartshipSummary()" class="editIcon">
      <!-- <img src="/images/new_ui/catalogues-edit.png" alt="Edit Delivery Address"> -->
      <span class="basic-icon edit-icon"></span>
    </a>
  </div>
  <div class="card-body">
    <div class="detail" *ngIf="partshipSummary.partShip">
      YES
    </div>
    <div class="detail" *ngIf="!partshipSummary.partShip">
      NO
    </div>
  </div>
</div>